import { useQuery } from '@tanstack/react-query';
import { OfficeMissingInfoService } from '../services/OfficeMissingInfoService';

export const officeMissingInfoKeys = {
  all: ['office-missing-info'] as const,
  credentials: (officeId?: string | null) =>
    [...officeMissingInfoKeys.all, 'credentials', officeId] as const,
  /** A child office's profile read for the modal without switching the store's selected office. */
  office: (officeId?: string | null) => [...officeMissingInfoKeys.all, 'office', officeId] as const,
};

interface IUseOfficeCredentialsArgs {
  /** The office the request is scoped to: the store's selected office, or the child a parent picked in the form. */
  officeId?: string | null;
  enabled: boolean;
}

/**
 * The selected office's software, insurance and specialty, read fresh rather than from
 * `state.userCredentials`: a failed office switch leaves the previous office's credentials there,
 * and re-sending that specialty would overwrite this office's.
 */
export const useOfficeCredentials = ({ officeId, enabled }: IUseOfficeCredentialsArgs) =>
  useQuery({
    queryKey: officeMissingInfoKeys.credentials(officeId),
    queryFn: () => OfficeMissingInfoService.getCredentials(officeId),
    enabled: enabled && !!officeId,
  });
